import React from "react";
import { Button } from "@progress/kendo-react-buttons";
import type { UploadDestination } from "./UploadDestinationPickerDialog";
import { formatUploadDestination } from "@presentation/components/inventory/components/uploadStatusPresentation";

interface UploadDestinationFieldProps {
  destination: UploadDestination | null;
  onChoose: () => void;
  disabled?: boolean;
  error?: string;
}

export const UploadDestinationField: React.FC<UploadDestinationFieldProps> = ({ destination, onChoose, disabled, error }) => (
  <div style={{ margin: "12px 0", overflowWrap: "anywhere" }}>
    <p>
      Destination: <strong>{destination ? formatUploadDestination(destination.rootPath, destination.folder) : "Choose a directory before uploading."}</strong>
    </p>
    <Button type="button" onClick={onChoose} disabled={disabled}>
      {destination ? "Change directory" : "Choose directory"}
    </Button>
    {error && (
      <p role="alert" style={{ color: "#b91c1c", whiteSpace: "pre-wrap" }}>
        {error}
      </p>
    )}
  </div>
);
